import { createReducer } from "@reduxjs/toolkit";
import {
  GetCustomerTypeSuccess,
  getCustomerDropdownSuccess,
  getSupplierDropdownSuccess,
  getSupplierListSuccess,
  LoadingData,
  getSupplierAttachmentInfoSuccess,
  saveSupplierAttachmentInfoSuccess,
  getSupplierReviewDateListSuccess,
  getSupplierQuestionaryListSuccess,
  getSupplierMainMenuAuditListSuccess,
  getSupplierMainMenuAuditDateListSuccess,
  getSupplierMainMenuQuestionnaireListSuccess,
  getSupplierMainMenuRiskAnalysisListSuccess,
  getSupplierMainMenuRequestsListSuccess,
  getSupplierActionPlanListSuccess,
  getSupplierCompletedQuestionaryListSuccess,
  SaveAndEditContinue
} from "./companyAction";

export interface ICompanyState {
  isLoading: boolean;
  supplierDropdownData: Array<any>;
  customerDropdownData: Array<any>;
  customerTypeList: Array<any>;
  supplierList: Array<any>;
  supplierReviewDateList: Array<any>;
  dataCount: number;
  attachmentInfo: any;
  questionaryList?: Array<any>;
  supplierAuditList?: Array<any>;
  supplierAuditDateList?: Array<any>;
  supplierQuestionnaireList?: Array<any>;
  supplierRiskAnalysisList?: Array<any>;
  supplierRequests?: Array<any>;
  supplierActionPlanList?: Array<any>;
  completedQuestionnaireList?: Array<any>;
  IsSaveAndEditContinue: boolean;
}

const initialState: ICompanyState = {
  dataCount: 0,
  isLoading: false,
  supplierDropdownData: [],
  customerDropdownData: [],
  customerTypeList: [],
  supplierList: [],
  supplierReviewDateList: [],
  attachmentInfo: {},
  questionaryList: [],
  supplierAuditList: [],
  supplierAuditDateList: [],
  supplierQuestionnaireList: [],
  supplierRiskAnalysisList: [],
  supplierRequests: [],
  supplierActionPlanList: [],
  completedQuestionnaireList: [],
  IsSaveAndEditContinue: false,
};

export const companyReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(LoadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getSupplierReviewDateListSuccess, (state, action) => {
      state = {
        ...state,
        supplierReviewDateList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getCustomerDropdownSuccess, (state, action) => {
      state = {
        ...state,
        customerDropdownData: action.payload?.data,
      };
      return state;
    })
    .addCase(getSupplierDropdownSuccess, (state, action) => {
      state = {
        ...state,
        supplierDropdownData: action.payload?.data,
      };
      return state;
    })
    .addCase(GetCustomerTypeSuccess, (state, action) => {
      state = {
        ...state,
        customerTypeList: action.payload?.data,
      };
      return state;
    })
    .addCase(getSupplierListSuccess, (state, action) => {
      state = {
        ...state,
        supplierList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getSupplierAttachmentInfoSuccess, (state, action) => {
      state = {
        ...state,
        attachmentInfo: action.payload,
      };
      return state;
    })
    .addCase(saveSupplierAttachmentInfoSuccess, (state, action) => {
      state = {
        ...state,
        attachmentInfo: action.payload,
      };
      return state;
    })
    .addCase(getSupplierQuestionaryListSuccess, (state, action) => {
      state = {
        ...state,
        questionaryList: action.payload?.data,
      };
      return state;
    })
    .addCase(getSupplierCompletedQuestionaryListSuccess, (state, action) => {
      state = {
        ...state,
        completedQuestionnaireList: action.payload?.data,
      };
      return state;
    })
    .addCase(getSupplierMainMenuAuditListSuccess, (state, action) => {
      state = {
        ...state,
        supplierAuditList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getSupplierMainMenuAuditDateListSuccess, (state, action) => {
      state = {
        ...state,
        supplierAuditDateList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getSupplierMainMenuQuestionnaireListSuccess, (state, action) => {
      state = {
        ...state,
        supplierQuestionnaireList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(getSupplierMainMenuRiskAnalysisListSuccess, (state, action) => {
      state = {
        ...state,
        supplierRiskAnalysisList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getSupplierMainMenuRequestsListSuccess, (state, action) => {
      state = {
        ...state,
        supplierRequests: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getSupplierActionPlanListSuccess, (state, action) => {
      state = {
        ...state,
        supplierActionPlanList: action.payload?.data,
      };
      return state;
    })
     .addCase(SaveAndEditContinue, (state, action) => {
          state = {
            ...state,
            IsSaveAndEditContinue: action.payload,
          };
          return state;
        })
    
});
